//checkerror
export const CHECK_ERROR = 'CHECK_ERROR';

//BIO
export const SET_BIO = 'SET_BIO';
export const ONCHANGE_BIO = 'ONCHANGE_BIO';
export const ONCHANGE_BIO_PRESENT_NATIONALITY = 'ONCHANGE_BIO_PRESENT_NATIONALITY';

//language
export const SET_LANGUAGE = 'SET_LANGUAGE';

//Phone Number
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';

//university
export const SET_UNIVERSITY = 'SET_UNIVERSITY';

//school
export const SET_SCHOOL = 'SET_SCHOOL';

//Skill
export const SET_SKILL = 'SET_SKILL';

//Profesional Societies
export const SET_PROFESIONAL_SOCIETIES = 'SET_PROFESIONAL_SOCIETIES';
export const SET_PROFESIONAL_SOCIETIES_WITH_OUT_SHOW = 'SET_PROFESIONAL_SOCIETIES_WITH_OUT_SHOW';

//Portofolio
export const SET_PORTOFOLIO = 'SET_PORTOFOLIO';

//Publication
export const SET_PUBLICATION = 'SET_PUBLICATION';
export const SET_PUBLICATION_WITH_OUT_SHOW = 'SET_PUBLICATION_WITH_OUT_SHOW';

//Employment Record
export const SET_EMPLOYMENT_RECORDS = 'SET_EMPLOYMENT_RECORDS';

//Disabilities
export const SET_DISABILITIES = 'SET_DISABILITIES';
export const ONCHANGE_DISABILITIES = 'ONCHANGE_DISABILITIES';
export const SET_DISABILITIES_WITH_OUT_SHOW = 'SET_DISABILITIES_WITH_OUT_SHOW';

//Dependent
export const SET_DEPENDENTS = 'SET_DEPENDENTS';
export const SET_DEPENDENTS_WITHOUT_SHOW = 'SET_DEPENDENTS_WITHOUT_SHOW';

//LegalPermanentResidenceStatus
export const SET_LEGAL_PERMANENT_RESIDENCE_STATUS = 'SET_LEGAL_PERMANENT_RESIDENCE_STATUS';
export const SET_LEGAL_PERMANENT_RESIDENCE_STATUS_WITH_OUT_SHOW = 'SET_LEGAL_PERMANENT_RESIDENCE_STATUS_WITH_OUT_SHOW';
export const ONCHANGE_LEGAL_PERMANENT_RESIDENCE_STATUS = 'ONCHANGE_LEGAL_PERMANENT_RESIDENCE_STATUS';

//Legal Step
export const SET_LEGAL_STEP = 'SET_LEGAL_STEP';
export const SET_LEGAL_STEP_WITH_OUT_SHOW = 'SET_LEGAL_STEP_WITH_OUT_SHOW';
export const ONCHANGE_LEGAL_STEP = 'ONCHANGE_LEGAL_STEP';

//Relative IN UN EMPLOYED
export const SET_RELATIVE_EMPLOYED = 'SET_RELATIVE_EMPLOYED';
export const SET_RELATIVE_EMPLOYED_WITH_OUT_SHOW = 'SET_RELATIVE_EMPLOYED_WITH_OUT_SHOW';

//Previously Submitted UN
export const SET_PREVIOUSLY_SUBMITTED_FOR_UN = 'SET_PREVIOUSLY_SUBMITTED_FOR_UN';
export const SET_PREVIOUSLY_SUBMITTED_FOR_UN_WITH_OUT_SHOW = 'SET_PREVIOUSLY_SUBMITTED_FOR_UN_WITH_OUT_SHOW';

//Permanent Civil Servants
export const SET_PERMANENT_CIVIL_SERVANTS = 'SET_PERMANENT_CIVIL_SERVANTS';
export const SET_PERMANENT_CIVIL_SERVANTS_WITH_OUT_SHOW = 'SET_PERMANENT_CIVIL_SERVANTS_WITH_OUT_SHOW';

//References
export const SET_REFERENCES = 'SET_REFERENCES';

//Relevan fact
export const SET_RELEVAN_FACT = 'SET_RELEVAN_FACT';
export const SET_RELEVAN_FACT_WITH_OUT_SHOW = 'SET_RELEVAN_FACT_WITH_OUT_SHOW';
export const ONCHANGE_RELEVAN_FACT = 'ONCHANGE_RELEVAN_FACT';

//Bio Adress
export const SET_BIO_ADDRESS = 'SET_BIO_ADDRESS';
export const ONCHANGE_BIO_ADDRESS = 'ONCHANGE_BIO_ADDRESS';
export const ONCHANGE_MULTI_SELECT_BIO = 'ONCHANGE_MULTI_SELECT_BIO';
export const ONCHANGE_PERMANENT_ADDRESS_BIO = 'ONCHANGE_PERMANENT_ADDRESS_BIO';
export const ONCHANGE_PRESENT_ADDRESS_BIO = 'ONCHANGE_PRESENT_ADDRESS_BIO';
export const CHECK_ERROR_BIO = 'CHECK_ERROR_BIO';

//CV And Signature
export const SET_CV_AND_SIGNATURE = 'SET_CV_AND_SIGNATURE';

// Roster
export const SET_PROFILE_ROSTER_PROCESS = 'SET_PROFILE_ROSTER_PROCESS';
export const SET_BULK_ROSTER_PROCESS = 'SET_BULK_ROSTER_PROCESS';
export const RESET_PROFILE_ROSTER_PROCESS = 'RESET_PROFILE_ROSTER_PROCESS';
export const SET_PROFILE_ROSTER_PROCESS_DATA = 'SET_PROFILE_ROSTER_PROCESS_DATA';

// ALREADY IMMAPER
export const SET_ALREADY_IMMAPER = 'SET_ALREADY_IMMAPER';
export const SET_BULK_ALREADY_IMMAPER = 'SET_BULK_ALREADY_IMMAPER';
export const RESET_ALREADY_IMMAPER = 'RESET_ALREADY_IMMAPER';

// RESET PROFILE
export const RESET_PROFILE = 'RESET_PROFILE';
export const RESET_TAB = 'RESET_TAB';
